import pLimit from 'p-limit';

export const PROJECT_MODEL_LIMIT = 100000;
export const PROJECT_MODEL_LABEL_LIMIT = 1000;

export const MAX_COMPETENCY_QUESTIONS = 20;

export const MAX_FILE_SIZE_IN_MB = 500;

/**
 * how many lines to show in UploadDialog
 */
export const MAX_CSV_VISIBLE_LINES = 25;

/**
 * how many rows of a CSV we retain as a stored preview; CSVs with more rows
 * than this are marked partial and must be re-uploaded at publish time
 */
export const MAX_CSV_PARSE_LINES = 25;

export const MAX_DATA_SOURCE_PREVIEW_ROWS = 25;

export const MAX_CSV_VOICEBOX_LINES = 25;

export const limitConcurrentRequests = pLimit(4);

/**
 * how many suggestions to include in advanced property editors
 */
export const MAX_PROPERTY_SUGGESTION_ITEMS = 10;

/**
 * how long to allow useQuery to wait before refetch
 */
export const QUERY_STALE_TIME = 3 * 60 * 1000;

/**
 * how many named graphs to query per database
 */
export const NAMED_GRAPH_LIMIT = 1000;
